var exports = {
  "hJ": "CharacterCounter.module__counter___SkxOcE",
  "$s": "CharacterCounter.module__counterButton___SkxOcE" + " " + "CharacterCounter.module__counter___SkxOcE",
  "N1": "CharacterCounter.module__counterSpan___SkxOcE" + " " + "CharacterCounter.module__counter___SkxOcE",
  "jL": "CharacterCounter.module__textDanger___SkxOcE",
  "gF": "CharacterCounter.module__textTertiary___SkxOcE",
};

module.exports = exports;
